/* eslint-disable react/prop-types */
import CommuterScoreGauge from "./CommuterScoreGauge";
import NearestHighwaysList from "./NearestHighwaysList";
import ScoreTooltip from "./ScoreTooltip";



/**
 * CommuterScoreTab - Renders the Commuter Score tab content including
 * a heading with triangle icon and tooltip, score gauge, nearest highways
 * list, and a disclaimer. Handles loading and error states.
 *
 * @param {number} score - Normalized commuter score (0-100)
 * @param {string} ratingTier - "Excellent" | "Good" | "Fair" | "Poor"
 * @param {string} tierColor - Hex color for the tier
 * @param {Array<{name: string, distance: number}>} nearestHighways - Sorted highway list
 * @param {boolean} isLoading - Whether data is still being fetched
 * @param {boolean} hasError - Whether the fetch failed
 * @param {Function} onLearnMoreClick - Optional callback for tooltip "Learn More"
 */
const CommuterScoreTab = ({
  score,
  ratingTier,
  tierColor,
  nearestHighways = [],
  isLoading = false,
  hasError = false,
  onLearnMoreClick,
}) => {
  return (
    <div className="commuter-score-tab">
      {/* Header: score icon + heading + tooltip */}
      <div className="commuter-score-tab__header">
        <img
          src="/assets/images/pdp/score.png"
          alt=""
          aria-hidden="true"
          className="commuter-score-tab__icon-img"
        />
        <h3 className="commuter-score-tab__heading">Commuter Score</h3>
        <ScoreTooltip onLearnMoreClick={onLearnMoreClick} />
      </div>

      {/* Content area: loading, error, or score display */}
      <div className="commuter-score-tab__content">
        {isLoading && (
          <div className="commuter-score-tab__loading" aria-live="polite">
            <div className="commuter-score-tab__spinner" aria-hidden="true" />
            <span>Loading commuter score...</span>
          </div>
        )}

        {!isLoading && hasError && (
          <p className="commuter-score-tab__error" role="alert">
            Commuter score is currently unavailable
          </p>
        )}

        {!isLoading && !hasError && (
          <>
            <CommuterScoreGauge
              score={score}
              ratingTier={ratingTier}
              color={tierColor}
            />
            <hr className="commuter-score-tab__divider" />
            <NearestHighwaysList highways={nearestHighways} />
          </>
        )}
      </div>
    </div>
  );
};

export default CommuterScoreTab;
